import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { useTranslate } from '@tolgee/react';
import { AwsPdfResponse } from '../AwsGraphs';

/**
 * Props for TopExpensesBar component.
 */
export interface TopExpensesBarProps {
    data: AwsPdfResponse;
}

/**
 * Renders a bar chart showing the top 10 expenses by service.
 * @param {TopExpensesBarProps} props - The props for the component.
 */
const TopExpensesBar: React.FC<TopExpensesBarProps> = ({ data }) => {
    const { t } = useTranslate();
    const totalByServiceMap = data.total_by_service.item_total;
    const top10expends = Object.entries(totalByServiceMap)
        .sort(([, valueA], [, valueB]) => valueB - valueA)
        .slice(0, 10);
    const top10expendsvalue = top10expends.map(([, value]) => value) || [];
    const top10expendsname = top10expends.map(([key]) => key) || [];
    const modifiedTop10ExpendsName = top10expendsname.map((name) => name.split(' '));
    const options: ApexOptions = {
        chart: {
            type: 'bar',
            fontFamily: 'inherit'
        },
        colors: ['#ef11e9', '#fad0fe', '#0003c9'],
        xaxis: {
            categories: modifiedTop10ExpendsName
        },
        plotOptions: {
            bar: {
                horizontal: false
            }
        },
        dataLabels: {
            enabled: false
        }
    };
    const series = [
        {
            name: t('pdf_success.charts.cost'),
            data: top10expendsvalue
        }
    ];
    return (
        <Box sx={{ width: '100%', display: 'flex' }}>
            <Card
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '2.5px solid #000000',
                    filter: 'drop-shadow(8px 8px 0 black)',
                    borderRadius: '.5rem',
                    minWidth: 300
                }}
            >
                <CardContent
                    sx={{
                        pt: 2,
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 2
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 18 }}>
                            {t('pdf_success.charts.top_expenses.title')}
                        </Typography>
                        <Typography variant="h5">{t('pdf_success.charts.top_expenses.description')}</Typography>
                    </Box>
                    <Chart options={options} series={series} type="bar" height={300} />
                </CardContent>
            </Card>
        </Box>
    );
};

export default TopExpensesBar;
